export const ROLES = {
  Member: "member",
  Leader: "leader",
  Admin: "admin",
};
